import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Desktop, Mobile } from '../../../App';
import hasDirectUsersBadge from '../../../assets/images/hasDirectUsersBadge.png';
import { H5, P3 } from '../../../styles/FontStyles';
import { Button, UserImageCircle } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconStructureAlert } from '../../../styles/Icons';
import { FlexCenter } from '../../../styles/stylesStyled';
import {
  addDirectBreadCrumb,
  clearBreadCrumbs,
  getDirectMembers,
  getDirectTeamLegUsers
} from '../myTeamBackOffice.actions';

import {
  AlertIcon,
  AlertWrapper,
  DirectLeftRightWrapper,
  DirectsVR,
  DirectsWrapper,
  DirectUserWrap,
  FlexJustifyCenter,
  LevelOneInfoStyled
} from '../MyTeamBackofficeStyled';

import { LevelOne, UserVerifications } from '../Structure/common';
import DirectRootTeamMemberDesktop from './DirectRootTeamMemberDesktop';
import { DirectRootTeamMemberInfo } from './DirectRootTeamMemberInfo';
import RootTeamMemberMobile from './DirectRootTeamMemberMobile';
import { LevelZero } from '../common/desktop';
import { ZeroLevelInfo } from '../Structure/TeamStructure/mobile/LevelZero/ZeroLevelInfo';
const Direct = () => {
  const { t } = useTranslation('myTeam');
  const dispatch = useDispatch();
  const countPerPage = 20;
  let [numberOfPageLeft, setNumberOfPageLeft] = useState(1);
  let [numberOfPageRight, setNumberOfPageRight] = useState(1);
  const {
    leftDirectUsers,
    rightDirectUsers,
    directTeamMember,
    directTeamMemberInfo
  } = useSelector((state) => state.myTeamBackoffice);

  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (!directTeamMember) dispatch(getDirectMembers(null, countPerPage));
    dispatch(clearBreadCrumbs());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const getUserImage = (teamMember) => {
    return (
      <div
        onClick={() => {
          dispatch(getDirectMembers(teamMember.id, countPerPage));
          dispatch(addDirectBreadCrumb(teamMember.id));
        }}>
        {teamMember.directUsersCount > 0 && (
          <div
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              marginLeft: 'auto',
              marginRight: 'auto',
              width: 70
            }}>
            <div style={{ float: 'right', marginTop: -5 }}>
              <img src={hasDirectUsersBadge} alt='' />
            </div>
          </div>
        )}
        {teamMember?.hasNoPackage ||
        teamMember?.hasUnpaidPackage ||
        teamMember?.isNotQualifiedPartner ||
        teamMember?.isUserNotVerified ? (
          <AlertWrapper>
            <UserImageCircle
              image={teamMember?.profileImageUrl}
              avatar
              avatarSize='20px'
              size='40px'
              margin='0 0 12px 0'
            />
            <AlertIcon color={color.colors.error500}>
              <Icon pointer w='34px' color={color.appLayout.footerIconColor}>
                <IconStructureAlert width={3} height={10} />
              </Icon>
            </AlertIcon>
          </AlertWrapper>
        ) : (
          <UserImageCircle
            image={teamMember?.profileImageUrl}
            avatar
            avatarSize='20px'
            size='40px'
            margin='0 0 12px 0'
          />
        )}
      </div>
    );
  };

  const LevelOneInfoComponent = () => {
    return (
      <LevelOneInfoStyled open={open}>
        <DirectRootTeamMemberInfo />
        <UserVerifications teamMember={directTeamMemberInfo} />
      </LevelOneInfoStyled>
    );
  };

  const UsersWithEmptySlots = (users) => {
    const DirectUsersWithEmptySlots = [...users];
    if (users.length < 16) {
      for (let i = 0; (i = 16 - DirectUsersWithEmptySlots?.length); i++) {
        DirectUsersWithEmptySlots.push({ value: 'emptyBox' });
      }
    }
    return DirectUsersWithEmptySlots;
  };

  // if (isLoadingDirect) return <Spinner fullScreen={true} />;

  const handleScrollLeft = () => {
    let numOfPage = numberOfPageLeft;
    numOfPage = numOfPage + 1;
    setNumberOfPageLeft(numOfPage);

    if (
      directTeamMemberInfo?.leftLegInfo?.totalDirectUsersCount !==
      leftDirectUsers?.length
    ) {
      dispatch(getDirectTeamLegUsers(null, numOfPage, countPerPage, 0));
    }
  };

  const handleScrollRight = () => {
    let numOfPage = numberOfPageRight;
    numOfPage = numOfPage + 1;
    setNumberOfPageRight(numOfPage);
    if (
      directTeamMemberInfo?.rightLegInfo?.totalDirectUsersCount !==
      rightDirectUsers?.length
    ) {
      dispatch(getDirectTeamLegUsers(null, numOfPage, countPerPage, 1));
    }
  };

  return (
    <>
      {/* <FlexJustifyCenter
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative'
        }}>
        <Desktop>
          <DirectRootTeamMemberDesktop />
        </Desktop>

        <Mobile onClick={() => setOpen(!open)} style={{ width: '100%' }}>
          <FlexCenter style={{ flexDirection: 'column' }}>
            <RootTeamMemberMobile member={directTeamMemberInfo} />
          </FlexCenter>
        </Mobile>
        <LevelOneInfoComponent />
      </FlexJustifyCenter> */}

      <Desktop>
        <FlexJustifyCenter>
          <LevelZero
            teamMember={directTeamMemberInfo}
            teamMemberInfo={directTeamMemberInfo}
            tab='direct'
          />
        </FlexJustifyCenter>
      </Desktop>
      <Mobile>
        <FlexJustifyCenter>
          <div onClick={() => setOpen(!open)}>
            <LevelOne teamMember={directTeamMemberInfo} />
          </div>
        </FlexJustifyCenter>
        <ZeroLevelInfo isOpen={open} teamMember={directTeamMemberInfo} />
      </Mobile>

      <DirectLeftRightWrapper>
        <div style={{ width: '50%' }}>
          <H5
            color={color.colors.neutral0}
            m='10px'
            mSM='0'
            style={{ textAlign: 'right' }}>
            {t('left_team')}:{' '}
            {directTeamMemberInfo?.leftLegInfo?.totalDirectUsersCount}
          </H5>
          <div style={{ position: 'relative' }}>
            <DirectsWrapper
              style={{ flexDirection: 'row-reverse' }}
              className='noScrollBar'>
              {UsersWithEmptySlots(leftDirectUsers)?.map((team, i) => {
                if (team.value !== 'emptyBox') {
                  return (
                    <DirectUserWrap key={i}>
                      {getUserImage(team)}
                      <P3
                        center
                        color={color.colors.neutral900}
                        style={{ maxWidth: '100%' }}>
                        <div className='truncated'>
                          <div>{team?.username}</div>
                        </div>
                      </P3>
                    </DirectUserWrap>
                  );
                } else {
                  return <DirectUserWrap noBackground key={i}></DirectUserWrap>;
                }
              })}
              {directTeamMemberInfo?.leftLegInfo?.totalDirectUsersCount !==
                leftDirectUsers?.length && (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center'
                  }}>
                  <Button w='100px' h='30px' mt='20' onClick={handleScrollLeft}>
                    Show more
                  </Button>
                </div>
              )}
            </DirectsWrapper>
          </div>
        </div>

        <DirectsVR />

        <div style={{ width: '50%' }}>
          <H5 color={color.colors.neutral0} m='10px' mSM='0'>
            {t('right_team')}:{' '}
            {directTeamMemberInfo?.rightLegInfo?.totalDirectUsersCount}
          </H5>
          <div style={{ position: 'relative' }}>
            {/* <DivFade /> */}

            <DirectsWrapper className='noScrollBar'>
              {UsersWithEmptySlots(rightDirectUsers)?.map((team, i) => {
                if (team.value !== 'emptyBox') {
                  return (
                    <DirectUserWrap key={i}>
                      {getUserImage(team)}
                      <P3
                        center
                        color={color.colors.neutral900}
                        style={{ maxWidth: '100%' }}>
                        <div className='truncated'>
                          <div>{team?.username}</div>
                        </div>
                      </P3>
                    </DirectUserWrap>
                  );
                } else {
                  return <DirectUserWrap noBackground key={i}></DirectUserWrap>;
                }
              })}
              {directTeamMemberInfo?.rightLegInfo?.totalDirectUsersCount !==
                rightDirectUsers?.length && (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center'
                  }}>
                  <Button
                    w='150px'
                    h='30px'
                    mt='20'
                    onClick={handleScrollRight}>
                    Show more
                  </Button>
                </div>
              )}
            </DirectsWrapper>
          </div>
        </div>
      </DirectLeftRightWrapper>
    </>
  );
};

export default Direct;
